import {useContext} from 'react';

import ProjectCustomMappingsContext from '../../contexts/ProjectCustomMappingsContext';

const useProjectsCustomMappings = () => {
  return useContext(ProjectCustomMappingsContext);
};

export default useProjectsCustomMappings;
